import { z } from 'zod';
import { transferOrderQuantitySchema } from './item-quantity.js';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
export const pickTransferOrderLotInputSchema = z.object({
    tagId: lowercasedRequiredUuidString('Lot is required.', 'Invalid lot selection.'),
    quantity: transferOrderQuantitySchema,
});
//# sourceMappingURL=pick-lot-input.js.map